module.exports = __webpack_public_path__ + "static/img/服务流程@2x.aa8bde6.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/服务流程@2x.png
// module id = 324
// module chunks = 379 380